module.exports = __webpack_public_path__ + "assets/smart-asset-pdf-icon.fa546c6b.svg";